<template>
  <div class="placeholder">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 826.36 845.25"
      class="placeholder__icon"
    >
      <g>
        <g>
          <path
            style="fill: #c9e094"
            d="M347.5,17.27v317.41c0,24.54-19.88,44.4-44.4,44.4H14.64C22.5,192.22,164.93,40.16,347.5,17.27Z"
          />
          <path
            style="fill: #9ddda9"
            d="M826.36,463.71v316.31c0,36.02-29.2,65.22-65.22,65.22h-316.33c-1.05,0-2.08-.02-3.11-.08-.1-1.18-.15-2.37-.15-3.59v-354.75c0-14.78,11.99-26.77,26.77-26.77h354.75c1.07,0,2.14.04,3.19.13.06,1.18.1,2.35.1,3.53Z"
          />
          <path
            style="
              fill: none;
              stroke: #9ddda9;
              stroke-miterlimit: 10;
              stroke-width: 28.58px;
            "
            d="M776.47,395.39c0,10.53-.43,20.95-1.27,31.25-3.94-1.02-8.04-1.57-12.29-1.57h-307.61c-27.03,0-49.14,22.11-49.14,49.14v302.12c-3.59.12-7.19.16-10.8.16-210.45,0-381.08-170.63-381.08-381.1,0-5.47.12-10.9.35-16.31C22.5,192.22,164.93,40.16,347.5,17.27c15.68-1.96,31.66-2.98,47.87-2.98,210.48,0,381.1,170.63,381.1,381.1Z"
          />
          <text
            style="
              fill: #4c5656;
              font-family: Comfortaa-SemiBold, Comfortaa;
              font-weight: 600;
              font-variation-settings: 'wght' 600;
              font-size: 252.15px;
            "
            transform="translate(163.78 330.87)"
          >
            <tspan x="0" y="0">+</tspan>
          </text>
          <text
            style="
              fill: #4c5656;
              font-weight: 600;
              font-variation-settings: 'wght' 600;
              font-size: 252.15px;
            "
            transform="translate(122.82 587.58) rotate(45)"
          >
            <tspan x="0" y="0">+</tspan>
          </text>
          <text
            style="
              fill: #4c5656;
              font-weight: 600;
              font-variation-settings: 'wght' 600;
              font-size: 252.15px;
            "
            transform="translate(505.37 334.24)"
          >
            <tspan x="0" y="0">÷</tspan>
          </text>
          <path
            style="fill: #9ddda9"
            d="M826.26,470.78c-1.78-33.38-29.52-60-63.35-60h-307.61c-34.97,0-63.43,28.46-63.43,63.43v307.61c0,33.95,26.85,61.77,60.41,63.35,1,.06,2,.08,3.02.08h307.61c34.97,0,63.45-28.46,63.45-63.43v-307.61c0-1.14-.04-2.29-.1-3.43ZM797.78,781.82c0,19.21-15.66,34.85-34.87,34.85h-307.61c-1.06,0-2.12-.04-3.16-.14-17.74-1.61-31.68-16.56-31.68-34.7v-307.61c0-19.21,15.64-34.85,34.85-34.85h307.61c18.01,0,32.89,13.74,34.68,31.3.12,1.16.18,2.35.18,3.55v307.61Z"
          />
          <path
            style="
              fill: none;
              stroke: #9ddda9;
              stroke-miterlimit: 10;
              stroke-width: 28.58px;
            "
            d="M6.6,425.06h328.37c33.36,0,60.41-27.05,60.41-60.41V14.3"
          />
          <g>
            <path
              style="fill: #fff"
              d="M682.77,610.95c-7.19,0-14.08,1.18-20.5,3.34v-67.23h-23.1v86.91h29.77c4.33-1.45,8.98-2.26,13.83-2.26,22.91,0,39.74,17.72,39.74,39.5s-16.83,39.5-39.74,39.5c-2.12,0-4.2-.15-6.23-.44v20.91c2.05.2,4.13.3,6.23.3,34.45,0,62.38-26.98,62.38-60.27s-27.93-60.27-62.38-60.27"
            />
            <polygon
              style="fill: #fff"
              points="639.18 660.52 639.18 695.66 556.86 591.66 556.86 692.4 533.35 692.4 533.35 547.1 549.28 547.1 639.18 660.52"
            />
          </g>
        </g>
      </g>
    </svg>
    <p class="placeholder__title">
      <slot name="title-placeholder"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'calculator-placeholder',
}
</script>

<style lang="scss" scoped>
.placeholder {
  display: none;

  @media screen and (min-width: 1200px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    border: 0.125rem solid #9ddda9;
    height: 100%;
  }

  &__icon {
    width: 3.875rem;
    height: 3.875rem;
  }

  &__title {
    font-size: 1.25rem;
    letter-spacing: 0.01em;
    font-weight: 600;
    color: #000;
    max-width: 12.9375rem;
    text-align: center;
  }
}
</style>
